<template>
  <MainNavbar class="style-three" />
  <PageTitle
    pageTitle="Menu"
    mainTitle="Menu"
    subTitle="Where Every Dish Tells A Unique Tale"
  />
  <MenuClassic />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PageTitle from "../components/Common/PageTitle.vue";
import MenuClassic from "../components/MenuClassic/MenuClassic.vue";

export default defineComponent({
  name: "MenuClassicPage",
  components: {
    MainNavbar,
    PageTitle,
    MenuClassic,
  },
});
</script>